"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "McpTokenService", {
    enumerable: true,
    get: function() {
        return McpTokenService;
    }
});
const _common = require("@nestjs/common");
const _nanoid = require("nanoid");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _dataUtils = require("~/utils/dataUtils");
const _globals = require("~/utils/globals");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let McpTokenService = class McpTokenService {
    async list(context, req) {
        const userId = req.user.id;
        return await _models.MCPToken.list(context, userId);
    }
    async create(context, payload, req) {
        var _payload_title;
        // Set required fields
        payload.fk_user_id = req.user.id;
        payload.fk_workspace_id = context.workspace_id;
        payload.base_id = context.base_id;
        payload.title = (_payload_title = payload.title) == null ? void 0 : _payload_title.trim();
        const mcp = await _models.MCPToken.insert(context, payload);
        return _extends({}, mcp, {
            base: await _models.Base.get(context, mcp.base_id),
            workspace: await _models.Workspace.get(mcp.fk_workspace_id)
        });
    }
    async regenerateToken(context, tokenId, payload, req) {
        const token = await _models.MCPToken.get(context, tokenId);
        if (!token) {
            _catchError.NcError.get(context).notFound('MCP token not found');
        }
        if (token.fk_user_id !== req.user.id) {
            _catchError.NcError.get(context).forbidden('Not authorized to modify this token');
        }
        payload.token = (0, _nanoid.nanoid)(32);
        const mcp = await _models.MCPToken.update(context, tokenId, payload);
        return _extends({}, mcp, {
            base: await _models.Base.get(context, mcp.base_id),
            workspace: await _models.Workspace.get(mcp.fk_workspace_id)
        });
    }
    async delete(context, tokenId, req) {
        const token = await _models.MCPToken.get(context, tokenId);
        if (!token) {
            _catchError.NcError.get(context).notFound('MCP token not found');
        }
        if (token.fk_user_id !== req.user.id) {
            _catchError.NcError.get(context).forbidden('Not authorized to delete this token');
        }
        const success = await _models.MCPToken.delete(context, tokenId);
        if (!success) {
            _catchError.NcError.internalServerError('Failed to delete MCP token');
        }
        return true;
    }
    async get(context, tokenId, req) {
        const token = await _models.MCPToken.get(context, tokenId);
        if (!token) {
            _catchError.NcError.get(context).notFound('MCP token not found');
        }
        if (token.fk_user_id !== req.user.id) {
            _catchError.NcError.get(context).forbidden('Not authorized to access this token');
        }
        return _extends({}, token, {
            base: await _models.Base.get(context, token.base_id),
            workspace: await _models.Workspace.get(token.fk_workspace_id)
        });
    }
    async listByUserId(context, req) {
        const userId = req.user.id;
        const tokens = await _models.MCPToken.listByUser(context, userId);
        const workspaceIds = new Set();
        const baseIds = new Set();
        tokens.forEach((token)=>{
            if (token.fk_workspace_id) workspaceIds.add(token.fk_workspace_id);
            if (token.base_id) baseIds.add(token.base_id);
        });
        const workspaceMap = new Map();
        const baseMap = new Map();
        await (0, _dataUtils.processConcurrently)([
            ...Array.from(workspaceIds),
            ...Array.from(baseIds)
        ], async (id)=>{
            try {
                if (workspaceIds.has(id)) {
                    const workspace = await _models.Workspace.get(id);
                    if (workspace == null ? void 0 : workspace.title) {
                        workspaceMap.set(id, workspace);
                    }
                } else {
                    const base = await _models.Base.get({
                        workspace_id: _globals.RootScopes.BYPASS,
                        base_id: _globals.RootScopes.BYPASS
                    }, id);
                    if (base == null ? void 0 : base.title) {
                        baseMap.set(id, base);
                    }
                }
            } catch (e) {
                this.logger.error('Failed to fetch base/workspace', e);
            }
        }, 5);
        return tokens.map((token)=>_extends({}, token, {
                workspace: token.fk_workspace_id ? workspaceMap.get(token.fk_workspace_id) || null : null,
                base: token.base_id ? baseMap.get(token.base_id) || null : null
            }));
    }
    constructor(){
        this.logger = new _common.Logger(McpTokenService.name);
    }
};
McpTokenService = _ts_decorate([
    (0, _common.Injectable)()
], McpTokenService);
